module.exports = __webpack_public_path__ + "img/icon-delete.ebd24ee0.svg";